import videojs from 'video.js';

const vjsSpacer = videojs.getComponent('Spacer');

class VjsFiller extends vjsSpacer {
  createEl(tag = 'div', props = {}, attributes = {}) {
    const el = super.createEl(tag, props, attributes);

    el.style.left = '0';
    el.style.width = '0';
    el.style.height = '22px';
    el.style.backgroundColor = 'rgba(70, 255, 160, 0.57)';
    el.style.position = 'absolute';
    el.style.zIndex = '9';

    return el;
  }

  buildCSSClass() {
    return `vjs-scrubber ${super.buildCSSClass()}`;
  }

  setTimeSpan(newStartTime, newEndTime) {
    const el = this.el();

    const duration = this.player().duration();

    // Cap to duration constraints
    this.startTime = Math.min(Math.max(newStartTime, 0), duration);
    this.endTime = Math.min(Math.max(newEndTime, 0), duration);

    // Set position
    const startAlpha = this.startTime / duration;
    const endAlpha = this.endTime / duration;

    el.style.left = `${startAlpha * 100}%`;
    el.style.width = `${(endAlpha - startAlpha) * 100}%`;
  }
}

export default VjsFiller;
